import { ContentSectionType } from "@/types/contentSectionType";

/** Single place to adjust which blueprint content rows allow preview edit. */
export const CONTENT_PREVIEW_EDIT_WHITELIST = {
  allowTitleByFormLabel: true,
  allowCtaContent: true,
  /** When false, text section font size select is read-only in the editor drawer. */
  allowTextSectionFontSizeEdit: true,
  sectionTypesAllowed: new Set<ContentSectionType>([ContentSectionType.Text]),
};
